import { Link } from 'react-router-dom';
import { episodes } from '@/mocks/siteData';
import EpisodeCard from '@/components/feature/EpisodeCard';

export default function LatestEpisodes() {
  const latest = [...episodes].slice(-6).reverse();

  return (
    <section className="w-full bg-background-100 border-y border-background-200">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="flex items-end justify-between gap-4 mb-8">
          <div>
            <div className="flex items-center gap-3 mb-2">
              <span className="w-1 h-6 bg-primary-500 rounded-full"></span>
              <h2 className="font-heading font-bold text-foreground-950 text-2xl md:text-3xl">
                最新剧情更新
              </h2>
            </div>
            <p className="text-sm text-foreground-500">近期更新的剧集内容，快速追更不迷路</p>
          </div>
          <Link
            to="/category/plot"
            className="hidden sm:inline-flex items-center gap-1 px-4 py-2 rounded-md border border-background-300 text-foreground-800 text-sm font-medium hover:border-accent-400 hover:text-accent-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {latest.map((ep) => (
            <EpisodeCard key={ep.episode} episode={ep} />
          ))}
        </div>

        <Link
          to="/category/plot"
          className="sm:hidden mt-6 w-full inline-flex items-center justify-center gap-1 px-4 py-2.5 rounded-md border border-background-300 text-foreground-800 text-sm font-medium"
        >
          查看全部剧情
          <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
        </Link>
      </div>
    </section>
  );
}